import React from 'react'
import Button, { iconType } from '../../atom/ButtonV2/Button'
import { useLocation, useNavigate } from 'react-router-dom'
export interface BtnSideBar{
  path: string;
  name: string;
  icon: iconType;
  regexEqual?: RegExp
}


export const LISTBTN : BtnSideBar[] = [
  {
    path: '/main/',
    name: 'Accueil',
    icon: 'home',
   
  },
  {
    path: '/main/dashboards',
    name: 'Dashboard',
    icon: 'dashboard',
    regexEqual: /^\/main\/dashboards(\/.*)?$/
  },
  {
    path: '/main/infra',
    name: 'Suivis Infra',
    icon: 'gauge',
    regexEqual: /^\/main\/infra(\/.*)?$/
  },
  {
    path: '/main/minigrid',
    name: 'Minigrid',
    icon: 'sun',
    regexEqual: /^\/main\/minigrid(\/.*)?$/    
  },

  {
    path: '/main/meters',
    name: 'Compteurs',
    icon: 'people',
    regexEqual: /^\/main\/meters(\/.*)?$/
  },

  {
    path: '/main/luminaires',
    name: 'Luminaires',
    icon: 'gauge',
    regexEqual: /^\/main\/luminaires(\/.*)?$/
  },

    {
      path: '/main/plan-bt',
      name: 'Plan BT',
      icon: 'map',
      regexEqual: /^\/main\/plan-bt(\/.*)?$/  
    },
    {
      path: '/main/setting',
      name: 'Paramètres',
      icon: 'setting',
      regexEqual: /^\/main\/setting(\/.*)?$/  
    },
    {
      path: '/main/extract',
      name: 'Extract',
      icon: 'export',
      regexEqual: /^\/main\/extract(\/.*)?$/
    }
]
export default function SideBar() {
    const navigate = useNavigate()
    const location = useLocation();


    const getIsActive = (path: string, regex?: RegExp) => {
      if(regex){
        return regex.test(location.pathname)
      }
      return location.pathname === path
    }



  return (
    <div >
       { LISTBTN.map((btn, index) => (
        <div style={{marginBottom: 8 }} key={index}>
        <Button  fullWidth height={50} onClick={() => {navigate(btn.path)}} variant='dashboard-btn' iconLeftType={btn.icon} size='medium' color={'secondary'} isActive={getIsActive(btn.path, btn.regexEqual)}>{btn.name}</Button>
        </div>
       ))
       } 

    </div>
  )
}
